import React, { useState } from "react";
import "./ContactUs.css";
import { useFormik } from "formik";
import { toast, ToastContainer } from "react-toastify";
import { axiosInstance_agent } from "../../axiosInstance-agent";
import CircularProgress from "@mui/material/CircularProgress";
import { Link, useNavigate } from "react-router-dom";
import * as Yup from "yup";

const validationSchema = Yup.object().shape({
  message : Yup.string().required("Please enter your report"),

})

export function ContactUs() {
  const [loading, setLoading] = useState(false);
  const storedData =
    JSON.parse(sessionStorage.getItem("matchmakerProfileData")) || {};
  const { agentId, matchmakerName, planType, publicToken,email,mobile } = storedData;

  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      message: "",
      user_id:agentId,
    },
    validationSchema:validationSchema,
    onSubmit: async (values, { resetForm }) => {
      try {
        setLoading(true);
        const response = await axiosInstance_agent.post(
          "admin/customer-contact-forms",
          values
        );
        if (response.data.status === true) {
          toast.success(
            response.data.message || "Request is Submitted successfully.."
          );
          resetForm();
          setLoading(false);
          setTimeout(() => {
            navigate("/matchmaker-profiles-uploaded");
          }, 3000);
        }
      } catch (error) {
        console.error("Submission failed:", error);
        toast.error("Submission failed! Please try again.");
        setLoading(false);
      }
    },
  });

  return (
    <>
      <ToastContainer />
      {loading && (
        <div className="loader-overlay">
          <CircularProgress style={{ color: "#f24464" }} />
        </div>
      )}
      <div className="contactBg">
        <form onSubmit={formik.handleSubmit}>
          <div className="container contact-content">
            <div className="contact-text">Contact us for help</div>
            <div className="contact-number">+91 8978260525</div>
            <div className="contact-email">support@nathicharami.in</div>
            <div className="contact-write">Write a Report <span className="text-danger">*</span></div>
            <div className="contact-report">
              <textarea
                placeholder="Type here"
                rows={4}
                onChange={formik.handleChange}
                name="message"
                value={formik.values.message}
              ></textarea>
               <div>
                  {formik.touched.message && formik.errors.message && (
                    <div className="text-danger">{formik.errors.message}</div>
                  )}
                </div>
            </div>
            <div className="btnContactContainer">
              <div className="btnSendMessage">
                <button>Send Message</button>
              </div>
              <Link to="/matchmaker-plans">
                <div className="btnCancelMessage">
                  <button>Cancel</button>
                </div>
              </Link>
            </div>
          </div>
        </form>
      </div>
    </>
  );
}
